import HeartBeats from 'containers/others/Heartbeats';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Alert, Col, Container, Row } from 'reactstrap';
import { isDevMode } from 'utils/constants';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import WelcomeComp from './WelcomeComp';

const Dashboard = (props) => {
  return (
    <div className="page-content">
      <Container fluid>
        {/* Render Breadcrumb */}
        <Breadcrumbs title={props.t('Dashboards')} breadcrumbItem={props.t('Dashboard')} />

        {isDevMode && (
          <Alert color="info" className="h4">
            This is the staging URL
          </Alert>
        )}

        <Row>
          <Col md={5}>
            <WelcomeComp />
          </Col>
        </Row>
        <Row className="mt-2">
          <Col md={12}>
            <HeartBeats />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(Dashboard);
